import { render, staticRenderFns } from "./AddBill.vue?vue&type=template&id=ba7c4b98&"
import script from "./AddBill.vue?vue&type=script&lang=js&"
export * from "./AddBill.vue?vue&type=script&lang=js&"
import style0 from "./AddBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports